import React from 'react';
import { CheckCircle, XCircle, Target, Award, Briefcase, TrendingUp } from 'lucide-react';
export function DetailsSection() {
  return <section className="w-full" data-id="element-99">
      {/* Target Audience */}
      <div className="bg-gray-50 py-16 px-4 sm:px-6 lg:px-8" data-id="element-100">
        <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-101">
          {/* Who it's for */}
          <div className="bg-white p-8 rounded-2xl shadow-sm border border-green-100" data-id="element-102">
            <h3 className="text-2xl font-bold text-navy mb-6 flex items-center" data-id="element-103">
              <span className="bg-green-100 text-green-600 p-2 rounded-full mr-3" data-id="element-104">
                <CheckCircle className="h-6 w-6" data-id="element-105" />
              </span>
              PARA QUIÉN ES ESTA GUÍA
            </h3>
            <ul className="space-y-4" data-id="element-106">
              <li className="flex items-start" data-id="element-107">
                <CheckCircle className="h-6 w-6 text-green-500 mr-3 flex-shrink-0" data-id="element-108" />
                <span className="text-gray-700" data-id="element-109">
                  Trabajadores hispanos en construcción, limpieza, almacén o
                  servicios.
                </span>
              </li>
              <li className="flex items-start" data-id="element-110">
                <CheckCircle className="h-6 w-6 text-green-500 mr-3 flex-shrink-0" data-id="element-111" />
                <span className="text-gray-700" data-id="element-112">
                  Inmigrantes con inglés básico o intermedio que quieren saltar
                  al mundo corporativo.
                </span>
              </li>
              <li className="flex items-start" data-id="element-113">
                <CheckCircle className="h-6 w-6 text-green-500 mr-3 flex-shrink-0" data-id="element-114" />
                <span className="text-gray-700" data-id="element-115">
                  Personas con disciplina dispuestas a dedicar 1 hora diaria a
                  su futuro.
                </span>
              </li>
              <li className="flex items-start" data-id="element-116">
                <CheckCircle className="h-6 w-6 text-green-500 mr-3 flex-shrink-0" data-id="element-117" />
                <span className="text-gray-700" data-id="element-118">
                  Padres y madres que quieren un mejor ejemplo para sus hijos.
                </span>
              </li>
              <li className="flex items-start" data-id="element-119">
                <CheckCircle className="h-6 w-6 text-green-500 mr-3 flex-shrink-0" data-id="element-120" />
                <span className="text-gray-700 font-medium" data-id="element-121">
                  Cualquiera que sepa que merece más que un trabajo de fuerza.
                </span>
              </li>
            </ul>
          </div>

          {/* Who it's not for */}
          <div className="bg-white p-8 rounded-2xl shadow-sm border border-red-100" data-id="element-122">
            <h3 className="text-2xl font-bold text-navy mb-6 flex items-center" data-id="element-123">
              <span className="bg-red-100 text-brandRed p-2 rounded-full mr-3" data-id="element-124">
                <XCircle className="h-6 w-6" data-id="element-125" />
              </span>
              PARA QUIÉN NO ES
            </h3>
            <ul className="space-y-4" data-id="element-126">
              <li className="flex items-start" data-id="element-127">
                <XCircle className="h-6 w-6 text-brandRed mr-3 flex-shrink-0" data-id="element-128" />
                <span className="text-gray-700" data-id="element-129">
                  Personas que buscan "dinero fácil" sin estudiar.
                </span>
              </li>
              <li className="flex items-start" data-id="element-130">
                <XCircle className="h-6 w-6 text-brandRed mr-3 flex-shrink-0" data-id="element-131" />
                <span className="text-gray-700" data-id="element-132">
                  Quienes no tienen autorización legal para trabajar en EE.UU.*
                </span>
              </li>
              <li className="flex items-start" data-id="element-133">
                <XCircle className="h-6 w-6 text-brandRed mr-3 flex-shrink-0" data-id="element-134" />
                <span className="text-gray-700" data-id="element-135">
                  Los que están conformes con su situación actual.
                </span>
              </li>
            </ul>
            <p className="text-xs text-gray-500 mt-6 italic" data-id="element-136">
              *Nota: El conocimiento te permite trabajar como freelance, pero
              para empleos corporativos W2 se requiere autorización.
            </p>
          </div>
        </div>
      </div>

      {/* How it works */}
      <div className="bg-navy text-white py-16 px-4 sm:px-6 lg:px-8" data-id="element-137">
        <div className="max-w-4xl mx-auto" data-id="element-138">
          <h2 className="text-3xl sm:text-4xl font-black text-center mb-12" data-id="element-139">
            CÓMO FUNCIONA (3 PASOS)
          </h2>

          <div className="space-y-8 relative before:absolute before:inset-0 before:ml-5 before:-translate-x-px md:before:mx-auto md:before:translate-x-0 before:h-full before:w-0.5 before:bg-gradient-to-b before:from-transparent before:via-brandBlue before:to-transparent" data-id="element-140">
            {/* Step 1 */}
            <div className="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group is-active" data-id="element-141">
              <div className="flex items-center justify-center w-10 h-10 rounded-full border-4 border-navy bg-brandBlue text-white font-bold shadow shrink-0 md:order-1 md:group-odd:-translate-x-1/2 md:group-even:translate-x-1/2 z-10" data-id="element-142">
                1
              </div>
              <div className="w-[calc(100%-4rem)] md:w-[calc(50%-2.5rem)] bg-navy-700 p-6 rounded-xl border border-brandBlue/30" data-id="element-143">
                <div className="flex items-center mb-3" data-id="element-144">
                  <Target className="h-6 w-6 text-brandBlue mr-2" data-id="element-145" />
                  <h3 className="font-bold text-xl" data-id="element-146">Elige Tu Ruta</h3>
                </div>
                <p className="text-gray-300" data-id="element-147">
                  Usando nuestra guía de selección, identificas cuál de las 4
                  certificaciones de Google es perfecta para tu personalidad y
                  nivel de inglés actual.
                </p>
              </div>
            </div>

            {/* Step 2 */}
            <div className="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group is-active" data-id="element-148">
              <div className="flex items-center justify-center w-10 h-10 rounded-full border-4 border-navy bg-brandRed text-white font-bold shadow shrink-0 md:order-1 md:group-odd:-translate-x-1/2 md:group-even:translate-x-1/2 z-10" data-id="element-149">
                2
              </div>
              <div className="w-[calc(100%-4rem)] md:w-[calc(50%-2.5rem)] bg-navy-700 p-6 rounded-xl border border-brandRed/30" data-id="element-150">
                <div className="flex items-center mb-3" data-id="element-151">
                  <Award className="h-6 w-6 text-brandRed mr-2" data-id="element-152" />
                  <h3 className="font-bold text-xl" data-id="element-153">Certifícate</h3>
                </div>
                <p className="text-gray-300" data-id="element-154">
                  Sigues el plan de estudio de 90 días con el método
                  "Double-Down": 45 minutos de estudio + inmersión pasiva
                  mientras trabajas.
                </p>
              </div>
            </div>

            {/* Step 3 */}
            <div className="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group is-active" data-id="element-155">
              <div className="flex items-center justify-center w-10 h-10 rounded-full border-4 border-navy bg-brandGold text-white font-bold shadow shrink-0 md:order-1 md:group-odd:-translate-x-1/2 md:group-even:translate-x-1/2 z-10" data-id="element-156">
                3
              </div>
              <div className="w-[calc(100%-4rem)] md:w-[calc(50%-2.5rem)] bg-navy-700 p-6 rounded-xl border border-brandGold/30" data-id="element-157">
                <div className="flex items-center mb-3" data-id="element-158">
                  <Briefcase className="h-6 w-6 text-brandGold mr-2" data-id="element-159" />
                  <h3 className="font-bold text-xl" data-id="element-160">
                    Aplica de Forma Inteligente
                  </h3>
                </div>
                <p className="text-gray-300" data-id="element-161">
                  Envías tu resume optimizado a las agencias de reclutamiento y
                  entras al portal VIP de empleadores de Google.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Credibility */}
      <div className="bg-brandBlue text-white py-12 px-4 sm:px-6 lg:px-8" data-id="element-162">
        <div className="max-w-5xl mx-auto" data-id="element-163">
          <h2 className="text-2xl font-bold text-center mb-10 uppercase tracking-wider" data-id="element-164">
            Lo que dicen los números
          </h2>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 text-center" data-id="element-165">
            <div className="bg-white/10 p-6 rounded-xl backdrop-blur-sm" data-id="element-166">
              <div className="text-4xl font-black text-brandGold mb-2" data-id="element-167">
                150+
              </div>
              <p className="text-sm font-medium" data-id="element-168">
                empresas en EE.UU. forman parte del consorcio de empleadores de
                Google.
              </p>
            </div>

            <div className="bg-white/10 p-6 rounded-xl backdrop-blur-sm" data-id="element-169">
              <div className="text-4xl font-black text-brandGold mb-2" data-id="element-170">
                $50k-$90k
              </div>
              <p className="text-sm font-medium" data-id="element-171">
                es el rango salarial promedio para estos perfiles en EE.UU.
              </p>
            </div>

            <div className="bg-white/10 p-6 rounded-xl backdrop-blur-sm" data-id="element-172">
              <div className="text-4xl font-black text-brandGold mb-2" data-id="element-173">
                90 días
              </div>
              <p className="text-sm font-medium" data-id="element-174">
                tiempo promedio para completar la certificación estudiando 1
                hora diaria.
              </p>
            </div>

            <div className="bg-white/10 p-6 rounded-xl backdrop-blur-sm" data-id="element-175">
              <div className="text-4xl font-black text-brandGold mb-2" data-id="element-176">
                $0-$49
              </div>
              <p className="text-sm font-medium" data-id="element-177">
                costo mensual de Coursera (o gratis con Financial Aid).
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}